import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getShiftAssignments = (params: any = {}) => {
  const query = new URLSearchParams();
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      query.set(key, params[key]);
    }
  }
  const queryString = query.toString();
  return api.get(`${BASE_URL}/api/v1/roster-assignments${queryString ? `?${queryString}` : ""}`);
};

export const createShiftAssignment = (payload: any) => {
  return api.post(`${BASE_URL}/api/v1/roster-assignments`, camelToSnake(payload));
};

export const updateShiftAssignment = (
  id: number,
  payload: { shiftDefinitionId: number; departmentId?: number; location?: string }
) => {
  return api.put(`${BASE_URL}/api/v1/roster-assignments/${id}`, camelToSnake(payload));
};

export const deleteShiftAssignment = (id: number) => {
  return api.delete(`${BASE_URL}/api/v1/roster-assignments/${id}`);
};

/**
 * Who's on duty by role for a given date and optional shift.
 * GET /api/v1/roster-assignments/on-duty?date=Y-m-d&shift_definition_id=?
 */
export const getOnDutyByRole = (params: { date: string; shift_definition_id?: number }) => {
  const query = new URLSearchParams();
  if (params.date) query.set("date", params.date);
  if (params.shift_definition_id != null && params.shift_definition_id !== undefined) {
    query.set("shift_definition_id", String(params.shift_definition_id));
  }
  const queryString = query.toString();
  return api.get(
    `${BASE_URL}/api/v1/roster-assignments/on-duty${queryString ? `?${queryString}` : ""}`
  );
};
